// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import pace from 'pace-js';
import './style/core/pace.css';
pace.start();
import App from './App.svelte';
import './global.css';
const app = new App({
    target: document.body,
    props: {},
});
export default app;
//# sourceMappingURL=svelte.bootstrap.js.map